export const FILTER_STORAGE_PREFIX = 'dashboard-';
export const SETTINGS_STORAGE_PREFIX = 'settings-';
export const REFRESH_SETTINGS_HOURS = 10;
export const SIDEBAR = 'sidebar';
export const ALLCOLLECTIONS = 'allCollections';
export const ENTITYURL = 'EntityURL';
export const EDITABLE = 'editable';
